import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-app" data-testid="auth-loading">
      <div className="w-10 h-10 rounded-full border-[3px] border-[var(--surface-accent)] border-t-[var(--brand)] animate-spin" />
    </div>
  );
}

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
